import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { alertService } from "../../services/helpers/alert.service";
import { nomService } from '../../services/api/nom.service';

const generateRandomString = (length) => {
	return [...Array(length)].map(() => (Math.random().toString(36)[2])).join('');
}

export const DashboardHeader = (props) => {
	
	const navigate = useNavigate();
	const [rol, setRol] = useState(3);

	const username = sessionStorage.getItem('numeUtilizator');
	const partener = sessionStorage.getItem('numePartener');
	//const rol = sessionStorage.getItem('rol');

	useEffect(() => {
		if (!sessionStorage.getItem('numeUtilizator')) {
			navigate('/');
		}

		nomService.getRole().then(response => { setRol(response) });
	}, [rol]);


	const handleChangePartner = () => {
		navigate('/dashboard/selectie-partener/');
	}

	const handleDisconnect = () => {
		sessionStorage.clear();
		navigate('/');
	}

	const roluri = ['', 'Administrator', 'User CMU', 'Non CMU', 'Medic MM'];

	

	const [lastClicked, setLastClicked] = useState(null);

	// Funcție pentru a trata click-ul pe element
	const handleMenuClick = (path) => {
		if (rol == 2 && path != "/dashboard/cautare") {
			alertService.error("Nu aveti acces la aceasta pagina!");
			return;
		}


		
		if (path === lastClicked) {
			setLastClicked(null);
			setLastClicked(path);
			if (path.includes("raport")) {
				path = path + "?q=" + generateRandomString(10);
			}
		} else {
			setLastClicked(path);
		}

		navigate(path);
	};

    return (
		<div id="header" name="header">
			<div className="wrap">
				<div className="d-flex justify-space-between ">
					<div className="fl">
						<div id="logo"><a className="no-text" href="http://www.reginamaria.ro/" title="Regina Maria">Regina Maria</a></div>
					</div>
					<div className="profil fr">
						<div className="clearfix">
							<div className="fl">
								<span className="db mr100 lh15">Bun venit <strong name="username" className="user_strong">{username}</strong>.
									<br />
									<span name="rol"> {roluri[rol]} </span>
								</span>
							</div>
							<div className="fl">
								<a className="btn db"
									name="deconectare"
									onClick={ handleDisconnect}
								>Deconectare</a>
							</div>
						</div>
						<div className="header-partener clearfix d-flex mt10">
							
							<div className="">
								<span className="db mr10">Partener: <span name="nume_partener">{partener}</span></span>
							</div> 
							{(rol == "1" || rol == "2") &&
								(<div className="">

									<button name="btn-partener"
										className="btn_partener"
										onClick={handleChangePartner}
									/>
								</div>)
							}
						</div>
					</div>
				</div>
				<ul id="menu">
					<li className="item1 first">
						<a className="no-text" onClick={() => handleMenuClick('/dashboard/cautare-pacient')} name="menu_cautare_pacienti">Cautare pacienti</a>
					</li>
					<li className="item2">
						<a className="no-text" onClick={() => handleMenuClick('/dashboard/cautare')} name="menu_cautare">Cautare istoric</a>
					</li>
					<li className="item3">
						<a className="no-text" onClick={() => handleMenuClick('/dashboard/contestatii')} name="menu_contestatii">Contestatii</a>
					</li>
					<li className="item4">
						<a className="no-text" name="menu_rapoarte">Rapoarte</a>
						<ul>
							<li><a onClick={() => handleMenuClick('/dashboard/raport-consultatii-nefinalizate')}>Consultatii nefinalizate</a></li>
							<li><a onClick={() => handleMenuClick('/dashboard/raport-consultatii-mm-nefinalizate')}>Consultatii MM nefinalizate</a></li>
							<li><a onClick={() => handleMenuClick('/dashboard/raport-servicii-respinse')}>Servicii respinse</a></li>
							<li><a onClick={() => handleMenuClick('/dashboard/raport-servicii-medicale-facturare')}>Servicii medicale pentru facturare</a></li>
							<li><a onClick={() => handleMenuClick('/dashboard/raport-fisa-mm-facturare')}>Fise MM pentru facturare</a></li>
							<li><a onClick={() => handleMenuClick('/dashboard/raport-servicii-medicale-prestate')}>Servicii medicale prestate</a></li>
						</ul>
					</li>
					<li className="item5">
						<a href="#" className="no-text" name="menu_administrare">Administrare</a>
						<ul>
							<li><a onClick={() => handleMenuClick('/dashboard/contul-meu')}>Contul meu</a></li>
							<li><a onClick={() => handleMenuClick('/dashboard/medici')}>Medici</a></li>
							<li><a onClick={() => handleMenuClick('/dashboard/lista-fisiere')}>Lista fisiere</a></li>
							<li><a href="/manual/manual.pdf" target="_blank">Manual</a></li>
						</ul>
					</li>
					<li className="item6"><a className="no-text" name="menu_contact"  onClick={() => handleMenuClick('/dashboard/contact') }>Contact</a></li>
				</ul>
			</div>
		</div>
    );
}